import {
  INIT_PROBLEM,
  INIT_CHAPTER_LIST,
  INIT_SIGNOUT,
  RESTORE_PROBLEM_STATE,
  WATCHED_HINT,
  WATCHED_SOLUTION,
  SAVE_PROBLEM_CODE,
  UPDATE_PROGRESS_STATE,
  PROBLEM_COMPLETED_MODAL,
  SAVE_SOLUTION,
  SAVE_VIDEO_COMPLETE_STATUS,
} from '../Actions/actionTypes';

const INIT_STATE = {
  watchedHint: false,
  watchedSolution: false,
  isCompleted: false,
  isPreviouslyCompleted: false,
  completedProblemModal: false,
};

const Problem = (state = INIT_STATE, action) => {
  switch (action.type) {
    case INIT_PROBLEM:
      return {
        ...state,
        isPreviouslyCompleted: action.isPreviouslyCompleted,
        language: action.language,
      };

    case INIT_CHAPTER_LIST:
      return {
        ...state,
        ...INIT_STATE,
      };

    case RESTORE_PROBLEM_STATE:
      return {
        ...state,
        watchedHint: action.watchedHint || false,
        watchedSolution: action.watchedSolution || false,
        isCompleted: action.isCompleted || false,
        isPreviouslyCompleted: action.isPreviouslyCompleted || false,
        completedProblemModal: action.completedProblemModal || false,
      };

    case INIT_SIGNOUT:
      return INIT_STATE;

    case WATCHED_HINT:
      return {
        ...state,
        watchedHint: action.details.watchedHint,
      };

    case SAVE_SOLUTION:
      const stateResponse = state.response;
      const problemID = action.problemID;
      const code = stateResponse && stateResponse[problemID] && stateResponse[problemID].code ? stateResponse[problemID].code : action.code ? action.code : '';
      let res = { ...state.response, [action.problemID]: { code, solution: action.solution } };
      return {
        ...state,
        response: { ...res },
      };

    case WATCHED_SOLUTION:
      return {
        ...state,
        watchedSolution: action.details.watchedSolution,
      };

    case SAVE_PROBLEM_CODE:
      let responseState = state.response;
      let challengeID = action.id;
      let challengeSolution = action.solution;
      let responseSolution = responseState && responseState[challengeID] && responseState[challengeID].solution ? responseState[challengeID].solution : '';
      let solution = challengeSolution ? challengeSolution : responseSolution;
      let response = { ...state.response, [action.id]: { code: action.code, solution } };

      return {
        ...state,
        response,
      };

    case UPDATE_PROGRESS_STATE:
      let completed = state.isPreviouslyCompleted || action.isCompleted ? true : false;
      return {
        ...state,
        isCompleted: completed,
        isPreviouslyCompleted: completed,
      };

    case PROBLEM_COMPLETED_MODAL:
      return {
        ...state,
        completedProblemModal: action.status,
      };

    case SAVE_VIDEO_COMPLETE_STATUS:
      return {
        ...state,
        watchedHint: action.hintStatus,
        watchedSolution: action.solutionStatus,
        isCompleted: action.completionStatus,
        isPreviouslyCompleted: action.completionStatus,
      };

    default:
      return state;
  }
};

export default Problem;
